// The WorkspaceCard's one round-trip to GET /api/firm/workspace.

import { useQuery } from "@tanstack/react-query";
import { fetchFirmWorkspace, type FirmWorkspace } from "../api/firmWorkspace";

export function useFirmWorkspace() {
  return useQuery<FirmWorkspace>({
    queryKey: ["firm", "workspace"],
    queryFn: fetchFirmWorkspace,
    staleTime: 60_000,
  });
}
